// extracted by mini-css-extract-plugin
export default {"container":"test_container__T2HMn"};